import { breakpoints } from './breakpoints';
import { palette } from './palette';
import { components } from './components';
import { typography } from './typography';
import { type ThemeOptions } from '@mui/material';

export const themeOptions: ThemeOptions = {
  breakpoints,
  palette,
  components,
  typography,
};
